import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Artistic%20soft%20focus%20composition%20of%20designer%20fashion%20items%20including%20leather%20handbags%20sneakers%20and%20folded%20clothing%20in%20cream%20beige%20and%20sand%20tones%20arranged%20on%20warm%20neutral%20surface%20gentle%20natural%20daylight%20from%20window%20minimal%20editorial%20photography%20sophisticated%20European%20aesthetic%20airy%20high%20key%20lighting%20soft%20shadows%20no%20text&width=1600&height=900&seq=hero-bg-v2&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-background-50" />

      <div className="relative z-10 w-full max-w-[900px] mx-auto px-4 md:px-10 text-center pt-16">
        <div className="space-y-3 md:space-y-4">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight tracking-tight">
            OOPBUY Spreadsheet
          </h1>
          <p className="text-xl md:text-3xl lg:text-4xl font-heading font-semibold text-white/90">
            Deutschland
          </p>
          <p className="text-lg md:text-2xl font-heading font-medium text-white/80">
            Der komplette Guide 2026
          </p>
        </div>

        <p className="mt-4 md:mt-6 text-sm md:text-base text-white/70 max-w-xl mx-auto leading-relaxed">
          Ihr vertrauensw&uuml;rdiger Einkaufsassistent f&uuml;r den DACH-Raum. Entdecken Sie Schuhe,
          Hoodies, T-Shirts, Jacken und mehr &ndash; sicher und einfach mit dem OOPBUY Spreadsheet.
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-primary-500 text-white text-sm md:text-base font-semibold hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
          >
            OOPBUY Spreadsheet
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-white text-foreground-950 text-sm md:text-base font-semibold hover:bg-white/90 transition-all cursor-pointer whitespace-nowrap"
          >
            Buy It Now
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </a>
        </div>

        <div className="mt-6 flex items-center justify-center gap-4 text-white/60 text-xs md:text-sm">
          <span className="flex items-center gap-1">
            <span className="w-4 h-4 flex items-center justify-center"><i className="ri-shield-check-line"></i></span>
            SSL-Verschl&uuml;sselt
          </span>
          <span className="flex items-center gap-1">
            <span className="w-4 h-4 flex items-center justify-center"><i className="ri-star-fill text-primary-400"></i></span>
            99+ TrustScore
          </span>
          <span className="flex items-center gap-1">
            <span className="w-4 h-4 flex items-center justify-center"><i className="ri-user-heart-line"></i></span>
            DACH-Optimiert
          </span>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="flex items-center gap-2 text-white/50 text-xs">
          <span>Scrollen</span>
          <span className="w-4 h-4 flex items-center justify-center animate-bounce">
            <i className="ri-arrow-down-line"></i>
          </span>
        </div>
      </div>
    </section>
  );
}